// Fade of the org chart tour card and spotlight between steps
export const TOUR_FADE_MS = 200
